import { render, staticRenderFns } from "./SkillHistory.vue?vue&type=template&id=4cf11a9a&scoped=true&"
import script from "./SkillHistory.vue?vue&type=script&lang=js&"
export * from "./SkillHistory.vue?vue&type=script&lang=js&"
import style0 from "./SkillHistory.vue?vue&type=style&index=0&id=4cf11a9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf11a9a",
  null
  
)

export default component.exports